export default function Person () {
	return (
		<svg width={16} height={16} viewBox='0 0 16 16'>
			<circle cx={8} cy={5} r={3}
				style={{stroke: 'var(--card-paragraph-hsl)', strokeWidth: 2, fill: 'none'}} />
			<path d='M 14 14 A 1 1 0 0 0 2 14'
				style={{stroke: 'var(--card-paragraph-hsl)', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round', fill: 'none'}} />
		</svg>
	);
};